<template>
    <v-container class="main-container" fluid>
        <v-row align="center" justify="center" class="img-layout">
            <img v-if="$vuetify.breakpoint.width > 768" src="https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-campaign/rental-flyer/pc-top.jpg" class="img" contain />
    
            <img v-else src="https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-campaign/rental-flyer/mobile-top.jpg" class="img" contain />

            <a href="https://forms.gle/Pz43KLh6uzHk9VyL7" @click="catch_click_event" target="_blank" style="display: contents;"
                ><img
                    src="https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-campaign/kiddycat_musio_button_202006.jpg" class="btn-img" contain
            /></a>

            <img v-if="$vuetify.breakpoint.width > 768" src="https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-campaign/rental-flyer/pc-bottom.jpg" class="img" contain />

            <img v-else
                src="https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-campaign/rental-flyer/mobile-bottom.jpg" class="img" contain
            />
        </v-row>

        <v-row align="center" class="faq-layout">
            <span class="section-title">
                よくある質問
            </span>

            <v-expansion-panels accordion>
                <v-expansion-panel v-for="list in this.faqLists" :key="list.title">
                    <v-expansion-panel-header>{{ list.title }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-expansion-panels accordion>
                            <v-expansion-panel v-for="l in list.q" :key="l.question">
                                <v-expansion-panel-header>{{
                                    l.question
                                }}</v-expansion-panel-header>
                                <v-expansion-panel-content class="pre-formatted">
                                    {{ l.answer }}
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
    </v-container>
</template>

<script>
import { lists } from '../utils/faqs'

export default  {
    data(){
        return{
            faqLists: lists
        }
    },

    mounted() {
        this.$ga.page('/mainpage');
    },

    methods: {
        catch_click_event: function() {
            this.$ga.event('今すぐ申し込む', 'クリック', '', 1)
        }
    }
}
</script>

<style lang="scss" scoped>

.main-container {
    max-width: 720px;
    margin: auto;
}

.row.img-layout{
    @media (max-width: 768px) {
        display:block;
        margin: auto;
    }
}

.img {
    max-width: 100%;
}

.btn-img {
    max-width: 427px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;

    @media (max-width: 768px) {
        max-width: 70%;
        margin-bottom: 30px;
    }
}

.faq-layout {
    padding: 50px 10px 0px 10px;

    @media (max-width: 768px) {
        padding: 30px 25px 0px 25px;
    }
}

.section-title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 15px;
    @media (max-width: 768px) {
        font-size: 24px;
    }
    text-align: center;
}

.pre-formatted {
    white-space: pre-line;
}

.v-expansion-panel-header{
    text-align: inherit;
    display: block;
}
</style>
